import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import App from './App'

// eslint-disable-next-line import/no-unresolved
import './styles/main.css'
import './styles/global.sass'

import ErrorBoundary from './components/ErrorBoundary'

Sentry.init({
	release: process.env.REACT_APP_VERSION,
	enabled: process.env.NODE_ENV !== 'development',
	// eslint-disable-next-line no-underscore-dangle
	environment: process.env.REACT_APP_SENTRY_ENV,
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [new Integrations.BrowserTracing()],
	tracesSampleRate: 0.05,
	ignoreErrors: ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications.', /^ResizeObserver loop/]
})

const container = document.getElementById('root')
if (!container) {
	throw new Error('Root element not found')
}

const root = createRoot(container)
root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
)
